module.exports = __webpack_public_path__ + "img/ethiopia.68d9e7f.webp";